/**
 * PersonAvatar — identity-coloured initials circle.
 *
 * PLATFORM, and its own module rather than a named export off a board. Three
 * different agents render it — "My Access", the team-access roster and the
 * mentor's trainee list — and it keys colour and initials the same way the
 * allocation board does, so a person reads as the same colour everywhere. That
 * only holds if there is one of it. It used to live inside AccessBoard, which
 * meant the mentor agent imported the access agent's board to draw a face.
 */
import { cn } from '@/lib/utils'
import { userColor, getInitials } from '@/lib/colors'
import type { UserRef } from './types'

const AVATAR_SIZE = {
  sm: 'h-5 w-5 text-[10px]',
  lg: 'h-11 w-11 text-[15px]',
} as const

export function PersonAvatar({ user, size }: { user: UserRef; size: 'sm' | 'lg' }) {
  const color = userColor(user.name, user.id)
  return (
    <span
      className={cn(
        'inline-grid shrink-0 place-items-center rounded-full font-semibold text-white',
        AVATAR_SIZE[size],
      )}
      style={{ backgroundColor: color }}
      aria-hidden="true"
    >
      {getInitials(user.name, user.id)}
    </span>
  )
}
